import { useQuery } from '@tanstack/react-query'
import { getOfferReviews } from 'tripPlanner/api'
import * as OfferDetailKeys from 'tripPlanner/hooks/reactQueryKeys/offerDetail'

const OFFER_REVIEWS_STALE_TIME = 15 * 60 * 1000

interface UseOfferReviewsOptions {
  offerId: string | undefined
  region: string
  enabled?: boolean
}

export default function useOfferReviews({
  offerId,
  region,
  enabled = true,
}: UseOfferReviewsOptions) {
  const queryResult = useQuery({
    queryKey: OfferDetailKeys.reviews(offerId ?? '', region),
    queryFn: () => getOfferReviews(offerId!, region),
    enabled: enabled && !!offerId,
    staleTime: OFFER_REVIEWS_STALE_TIME,
  })

  return {
    reviews: queryResult.data?.reviews ?? [],
    reviewsTotal: queryResult.data?.total ?? 0,
    isLoading: queryResult.isLoading && queryResult.fetchStatus !== 'idle',
  }
}
